<template>
  <el-drawer
    title="Actualizar cuentas por cobrar de proveedor"
    :visible.sync="showDrawer"
    :before-close="beforeClose"
    size="75%"
  >
    <el-card class="card">
      <div>
        <el-row>
          <el-col :span="3" :offset="1">
            <h2>Proveedor:</h2>
          </el-col>
          <el-col :span="10">
            <h2>
              <strong
                ><b>{{ supplier.Name }}</b></strong
              >
            </h2>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row
          class="flex-container"
          style="padding-bottom: 0px; margin-bottom: 0px"
        >
          <el-button
            type="primary"
            icon="el-icon-refresh"
            size="medium"
            @click="update"
            >Actualizar</el-button
          >
        </el-row>
        <el-row style="margin-top: 20px">
          <rabbey-table3
            :height="600"
            style="overflow: auto"
            ref="customerTable"
            :columns="UpdateSupplierAccountColumns"
            v-loading="loading"
            :border="true"
            :stripe="true"
            :data="FilteredData"
          />
        </el-row>
      </div>
    </el-card>
  </el-drawer>
</template>

<script>
import { UpdateSupplierAccountColumns } from "@/views/apps/ncfmovil/columnsTables/UpdateSupplierAccountColumns.js";
export default {
  name: "UpdateSupplierAccount",
  props: {
    supplier: {
      type: Object
    },
    showDrawer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      UpdateSupplierAccountColumns,
      loading: false,
      search: "",
      FilteredData: []
    };
  },
  computed: {
    dataClients() {
      let ClientsData = this.ClientePagoProveedoresDataDetail.map(
        (BalanceDetail) => {
          return {
            cardHolderId: BalanceDetail.cardHolderId,
            cardHolderName: BalanceDetail.cardHolderName
          };
        }
      );
      return ClientsData;
    }
  },
  watch: {
    showDrawer() {
      if (!this.showDrawer) {
        return;
      }
      this.GetSupplierTransactions();
    }
  },
  methods: {
    update() {
      this.$confirm(
        "Esta accion actualizara las cuentas por cobrar del proveedor.\nDesea continuar?",
        "Warning",
        {
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      )
        .then(() => {
          this.$http
            .put(`/api/tennos/UpdateSupplierTransactions/${this.supplier.Rnc}`)
            .then(() => {
              this.$message({
                showClose: true,
                message: `Se han actualizado las cuentas satisfactoriamente`,
                type: "success",
                center: true,
                offset: 30
              });
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: `${err.name}:  ${err.message} `,
                center: true
              });
            })
            .finally(this.GetSupplierTransactions);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Se ha cancelado la actualización"
          });
        });
    },
    async GetSupplierTransactions() {
      this.loading = true;
      //this.supplier.Rnc = "101008492";
      await this.$http
        .get(`/api/tennos/GetSupplierTransactions/${this.supplier.Rnc}`)
        .then((resp) => {
          //console.log(resp.data);
          this.FilteredData = resp.data;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
      //console.log("Master Report: ", await this.SupplierBalanceDataMaster)
    },
    beforeClose() {
      this.$emit("OncloseDetail");
    }
    // getSummaries(param) {
    //   const { columns, data } = param;
    //   const sums = [];
    //   columns.forEach((column, index) => {
    //     if (index < 1) {
    //       return;
    //     }
    //     if (index === 1) {
    //       sums[index] = "Totales";
    //       return;
    //     }
    //     const values = data.map(item => Number(item[column.property]));
    //     if (!values.every(value => isNaN(value))) {
    //       sums[index] = formatMonto(
    //         values.reduce((prev, curr) => {
    //           const value = Number(curr);
    //           if (!isNaN(value)) {
    //             return prev + curr;
    //           } else {
    //             return prev;
    //           }
    //         }, 0)
    //       );
    //     } else {
    //       sums[index] = "";
    //     }
    //   });

    //   return sums;
    // },
    // onCardHolderChanging(CardHolderId) {
    //   //console.log("CardHolderId: ", CardHolderId)
    //   //console.log("ClientePagoProveedoresDataDetail: ", this.ClientePagoProveedoresDataDetail)

    //   if (!CardHolderId) {
    //     this.FilteredData = this.CardHolderFiltered = this.ClientePagoProveedoresDataDetail;
    //   } else {
    //     this.FilteredData = this.CardHolderFiltered = this.ClientePagoProveedoresDataDetail.filter(
    //       balanceData => balanceData.cardHolderId === CardHolderId
    //     );
    //     //console.log("CardHolderFiltered: ", this.CardHolderFiltered)
    //   }
    // },
    // async onDiffChanging(concept) {
    //   switch (concept) {
    //     case "All": {
    //       this.FilteredData = this.ClientePagoProveedoresDataDetail;
    //       break;
    //     }
    //     case "Diff": {
    //       this.FilteredData = this.ClientePagoProveedoresDataDetail.filter(
    //         balanceData => balanceData.balanceDiff !== 0
    //       );
    //       break;
    //     }
    //     case "NoTDiff": {
    //       this.FilteredData = this.ClientePagoProveedoresDataDetail.filter(
    //         balanceData => balanceData.balanceDiff === 0
    //       );
    //       break;
    //     }
    //     default: {
    //       break;
    //     }
    //   }
    // }
  }
};
</script>

<style lang="css" scoped>
.flex-container {
  display: flex;
  justify-content: flex-end;
}

.supliers_select {
  min-width: 60%;
}

.card {
  margin: 10;
}
</style>
